export default "__VITE_ASSET__DDASZnVO__"